export const onlyNumber = (str: string) => str && str.replace(/\D/g, '');
